import { render, staticRenderFns } from "./postPage.vue?vue&type=template&id=6f25a0bc&scoped=true&"
import script from "./postPage.vue?vue&type=script&lang=ts&"
export * from "./postPage.vue?vue&type=script&lang=ts&"
import style0 from "./postPage.vue?vue&type=style&index=0&id=6f25a0bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f25a0bc",
  null
  
)

export default component.exports